/** Event name for the global keyboard shortcut that opens search. */
export const searchKeyboardShortcut = Symbol("searchKeyboardShortcut");
